import { DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutStatusCode extends Layout {
    panelMain: Panel;
    sourceEquipstatuscode: DataSource;
    switchDispatchAllowed: Switch;
    textboxBeginNotificationDays: Textbox;
    textboxCloseAfterExpirationDays: Textbox;
    textboxCode: Textbox;
    textboxDescription: Textbox;
    textboxPriority: Textbox;
    textboxType: Textbox;
}
